(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }
  
        connectedCallback() {
            this.header = document.querySelector('.section-header-mobile');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};
    
            if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            };
    
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
    
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
    
            this.createObserver();
        }
  
        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
  
        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
    
            observer.observe(this.header);
        }
  
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
        
                    this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                    }, 66);
        
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
    
            this.currentScrollTop = scrollTop;
        }
  
        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.header.style.top = '';
        }
  
        reveal() {
            const headerMultiSite = document.querySelector('.section-header-nav-multi-site');
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            if (headerMultiSite) {
                const height = headerMultiSite.offsetHeight;
                this.header.style.top = `${height}px`;
            }
        }
  
        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            this.header.style.top = '';
        }
    }
  
    customElements.define('sticky-header-mobile', StickyHeaderMobile);

    document.querySelector('[data-mobile-menu]').addEventListener('click', () => {
        document.body.classList.toggle('menu_open');
    })

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    function renderLogoMobile() {
        if ($("[data-menu-tab]").length > 0) {

            $(document).on("click", "[data-menu-tab] li", (event) => {
                var active = $(event.currentTarget).data("load-page"),
                    href = $(event.currentTarget).attr("href");

                $.cookie("page-url", active, {
                    expires: 1,
                    path: "/",
                });
            });

            var canonical = $("[canonical-shop-url]").attr("canonical-shop-url"),
            pageUrl = $.cookie("page-url"),
            menuTabItem,
            logoTabItem,
            menuItem;

            if (
                window.location.pathname.indexOf("/pages/") !== -1 &&
                window.page_active &&
                window.page_active != pageUrl
            ) {
                setCookie("page-url", window.page_active, 1);
                pageUrl = window.page_active;
            }
            
            if (pageUrl != null) {
                menuTabItem = $(`[data-load-page="${pageUrl}"]`);
                logoTabItem = $(`[data-load-logo-page="${pageUrl}"]`);
                menuItem = $(`[data-load-menu-page="${pageUrl}"]`);
            } else {
                menuTabItem = $("[data-load-page].is-active");
                logoTabItem = $("[data-load-logo-page].first");
                menuItem = $("[data-load-menu-page].is-active");
            }

            var menuTab = menuTabItem.closest("[data-menu-tab]");

            menuTab
                .find("[data-load-page]")
                .not(menuTabItem)
                .removeClass("is-active");
                logoTabItem.siblings().removeClass("is-active");
                menuItem.siblings().removeClass("is-active");
            if (pageUrl != "") {
                logoTabItem.addClass("is-active");
                menuTabItem.addClass("is-active");
                menuItem.addClass("is-active");
            } else {
                $("[data-load-page]:nth-child(1)").addClass("is-active");
                $("[data-load-logo-page]:nth-child(1)").addClass("is-active");
                $("[data-load-menu-page]:nth-child(1)").addClass("is-active");
            }

            const header = menuTabItem.closest(".header");

            
            if (header && window.innerWidth < 1025) {
                if (
                    window.location.pathname.indexOf("/pages/") !== -1 &&
                    window.page_active &&
                    window.page_active != pageUrl
                ) {
                    setCookie("page-url", window.page_active, 1);
                    pageUrl = window.page_active;
                }

                const logoMobile = $(".header-mobile .header__heading-link");
                const logDesktop = header.find(".header__heading-link.is-active");

                if (logDesktop.data("logo-mobile") == undefined) {
                    logoMobile.find("img").addClass("logo-show");
                    return;
                } else {
                    logoMobile.html(
                    `<img src="${logDesktop.data(
                        "logo-mobile"
                    )}" alt="${logDesktop.data(
                        "logo-mobile-alt"
                    )}" style="max-width: ${logoMobile.data(
                        "logo-width"
                    )}px; height: auto"/>`
                    );

                    logoMobile.find("img").addClass("logo-show");
                    if (pageUrl != "" && pageUrl != null)
                    logoMobile.attr("href", pageUrl);
                }
            }
        }
    }

    renderLogoMobile();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-multi-site');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    document.addEventListener('DOMContentLoaded', () => {customElements.define('sticky-header', StickyHeader)});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-basic');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-compact');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-full-elements');
if (sticky != undefined || sticky != null) {
    console.log("sticky full: " + sticky)

    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-hamburger');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('load', this.checkLoadPosition.bind(this));
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }
        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('load', this.checkLoadPosition);
          window.removeEventListener('scroll', this.onScrollHandler);
        }
        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }
        checkLoadPosition() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const headerGr = document.querySelectorAll(".shopify-section-group-header-group");

            if(headerGr[0].classList.contains('shopify-section-header-sticky')) {
                if(scrollTop > headerGr[0].offsetHeight && !this.header.classList.contains('scrolled-past-header')) {
                    this.header.classList.add('shopify-section-header-hidden');
                }
            } else {
                headerGr.forEach(item => {
                    if(item.classList.contains('shopify-section-header-sticky') ) {
                        const itemPrev = item.previousElementSibling;
                        const itemPrevHeight = itemPrev.offsetHeight;
                        const itemPrevTop = itemPrev.offsetTop;

                        if(scrollTop > itemPrevTop + itemPrevHeight && !this.header.classList.contains('scrolled-past-header')) {
                            this.header.classList.add('shopify-section-header-hidden');
                        }
                    }
                });
            }
        }
        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }
        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                    document.querySelector('body').classList.add("section-header-is-hidden")
                }
            }
          this.closeMenuDisclosure();
        }
        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-left-aligned');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.body.classList.remove('scrolled-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-utility');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-vertical-menu');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
                if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                    $('.vertical-menu').addClass('vertical-menu__hide');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
              if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                  if (document.body.classList.contains('template-index')) {
                      if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
                          $('.vertical-menu').removeClass('vertical-menu__hide');
                      }
                  }
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highfy-brand-showcase"] && !Shopify.designMode) return;
  try {
    

(function() {

  function initializeBrandsSlider(wrapper) {

    if (
      !wrapper ||
      wrapper.dataset.brandsInitialized === "true"
    ) {
      return;
    }

    wrapper.dataset.brandsInitialized = "true";

    const track = wrapper.querySelector(".brands-carousel-track");
    const dots = Array.from(wrapper.querySelectorAll(".brands-bullet-dot"));
    const cards = Array.from(wrapper.querySelectorAll(".brands-carousel-card"));
    const previousButton = wrapper.querySelector(".arrow-prev");
    const nextButton = wrapper.querySelector(".arrow-next");

    if (!track || cards.length === 0) {
      return;
    }

    let currentIndex = 0;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchCurrentX = 0;
    let touchCurrentY = 0;
    let isDragging = false;
    let resizeTimer = null;
    let autoplayTimer = null;

    const isAutoplay = wrapper.getAttribute("data-autoplay") === "true";
    const autoplaySpeed = parseInt(wrapper.getAttribute("data-autoplay-speed"), 10) || 2000;
    const pauseOnHover = wrapper.getAttribute("data-pause-on-hover") === "true";

    function getItemsPerView() {
      if (window.innerWidth <= 768) return 2;
      if (window.innerWidth <= 991) return 3;
      if (window.innerWidth <= 1200) return 4;
      return 5;
    }

    function getMaxSteps() {
      return Math.max(0, cards.length - getItemsPerView());
    }

    function normalizeCurrentIndex() {
      const maxSteps = getMaxSteps();
      if (currentIndex > maxSteps) currentIndex = maxSteps;
      if (currentIndex < 0) currentIndex = 0;
    }

    function updateNavigationState() {
      const navigationDisabled = getMaxSteps() === 0;
      if (previousButton) previousButton.disabled = navigationDisabled;
      if (nextButton) nextButton.disabled = navigationDisabled;
    }

    function updateSliderPosition() {
      normalizeCurrentIndex();
      const cardWidth = cards[0].getBoundingClientRect().width;
      const gap = window.innerWidth <= 768 ? 12 : 20;
      const offsetDistance = currentIndex * (cardWidth + gap);

      track.style.transform = "translateX(-" + offsetDistance + "px)";

      dots.forEach(function(dot, index) {
        if (index === currentIndex) {
          dot.classList.add("dot-active");
        } else {
          dot.classList.remove("dot-active");
        }
      });

      updateNavigationState();
    }

    function startAutoplay() {
      if (!isAutoplay || autoplayTimer) return;
      autoplayTimer = setInterval(function() {
        moveToNextSlide();
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function resetAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    function moveToNextSlide() {
      const maxSteps = getMaxSteps();
      if (maxSteps === 0) return;

      if (currentIndex < maxSteps) {
        currentIndex += 1;
      } else {
        currentIndex = 0;
      }

      updateSliderPosition();
    }

    function moveToPreviousSlide() {
      const maxSteps = getMaxSteps();
      if (maxSteps === 0) return;

      if (currentIndex > 0) {
        currentIndex -= 1;
      } else {
        currentIndex = maxSteps;
      }

      updateSliderPosition();
    }

    if (nextButton) {
      nextButton.addEventListener("click", function() {
        moveToNextSlide();
        resetAutoplay();
      });
    }

    if (previousButton) {
      previousButton.addEventListener("click", function() {
        moveToPreviousSlide();
        resetAutoplay();
      });
    }

    dots.forEach(function(dot) {
      dot.addEventListener("click", function() {
        const targetIndex = parseInt(dot.getAttribute("data-slide-target"), 10);
        const maxSteps = getMaxSteps();
        currentIndex = Math.min(targetIndex, maxSteps);
        updateSliderPosition();
        resetAutoplay();
      });
    });

    /* Pause on hover mechanism */
    if (pauseOnHover) {
      wrapper.addEventListener("mouseenter", function() {
        stopAutoplay();
      });

      wrapper.addEventListener("mouseleave", function() {
        startAutoplay();
      });
    }

    /* Touch events logic optimized for link clicks */
    track.addEventListener(
      "touchstart",
      function(event) {
        stopAutoplay();
        if (!event.touches || event.touches.length === 0) return;
        isDragging = true;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        touchCurrentX = touchStartX;
        touchCurrentY = touchStartY;
      },
      { passive: true }
    );

    track.addEventListener(
      "touchmove",
      function(event) {
        if (!isDragging || !event.touches || event.touches.length === 0) return;
        touchCurrentX = event.touches[0].clientX;
        touchCurrentY = event.touches[0].clientY;
      },
      { passive: true }
    );

    track.addEventListener("touchend", function() {
      if (!isDragging) return;

      const movementDistanceX = touchStartX - touchCurrentX;
      const movementDistanceY = touchStartY - touchCurrentY;

      if (
        Math.abs(movementDistanceX) > 50 &&
        Math.abs(movementDistanceX) > Math.abs(movementDistanceY)
      ) {
        if (movementDistanceX > 0) {
          moveToNextSlide();
        } else {
          moveToPreviousSlide();
        }
      }

      isDragging = false;
      touchStartX = 0;
      touchStartY = 0;
      touchCurrentX = 0;
      touchCurrentY = 0;
      startAutoplay();
    });

    track.addEventListener("touchcancel", function() {
      isDragging = false;
      touchStartX = 0;
      touchStartY = 0;
      touchCurrentX = 0;
      touchCurrentY = 0;
      startAutoplay();
    });

    window.addEventListener("resize", function() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function() {
        updateSliderPosition();
      }, 150);
    });

    updateSliderPosition();
    startAutoplay();
  }

  function initializeAllBrandsSliders(container) {
    const searchArea = container || document;

    if (searchArea.matches && searchArea.matches('[id^="BrandsSection-"]')) {
      initializeBrandsSlider(searchArea);
    }

    const wrappers = searchArea.querySelectorAll('[id^="BrandsSection-"]');
    wrappers.forEach(function(wrapper) {
      initializeBrandsSlider(wrapper);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      initializeAllBrandsSliders(document);
    });
  } else {
    initializeAllBrandsSliders(document);
  }

  document.addEventListener("shopify:section:load", function(event) {
    initializeAllBrandsSliders(event.target);
  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highfy-clean-banners"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const wrappers = document.querySelectorAll('[id^="BrandsSection-"]');

  wrappers.forEach(wrapper => {
    const track = wrapper.querySelector('.brands-carousel-track');
    const dots = wrapper.querySelectorAll('.brands-bullet-dot');
    const cards = wrapper.querySelectorAll('.brands-carousel-card');
    const prevBtn = wrapper.querySelector('.arrow-prev');
    const nextBtn = wrapper.querySelector('.arrow-next');

    if (cards.length === 0) return;

    let currentIndex = 0;

    function getItemsPerView() {
      if (window.innerWidth <= 768) return 2;
      if (window.innerWidth <= 991) return 3;
      return 4;
    }

    function getMaxSteps() {
      const itemsPerView = getItemsPerView();
      if (window.innerWidth <= 768) return Math.max(0, cards.length - 2);
      return Math.max(0, cards.length - itemsPerView);
    }

    function updateSliderPosition() {
      const isMobile = window.innerWidth <= 768;
      const maxSteps = getMaxSteps();

      if (currentIndex > maxSteps) {
        currentIndex = maxSteps;
      }
      if (currentIndex < 0) {
        currentIndex = 0;
      }

      if (isMobile) {
        const percentageOffset = currentIndex * 52;
        const totalGap = currentIndex * 12;
        track.style.transform = `translateX(calc(-${percentageOffset}% - ${totalGap}px))`;
      } else {
        const cardWidth = cards[0].clientWidth;
        const offsetDist = currentIndex * (cardWidth + 20); 
        track.style.transform = `translateX(-${offsetDist}px)`;
      }

      dots.forEach((dot, index) => {
        if (index === currentIndex) {
          dot.classList.add('dot-active');
        } else {
          dot.classList.remove('dot-active');
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const maxSteps = getMaxSteps();
        if (currentIndex < maxSteps) {
          currentIndex++;
        } else {
          currentIndex = 0; 
        }
        updateSliderPosition();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        if (currentIndex > 0) {
          currentIndex--;
        } else {
          currentIndex = getMaxSteps(); 
        }
        updateSliderPosition();
      });
    }

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const target = parseInt(dot.getAttribute('data-slide-target'));
        const maxSteps = getMaxSteps();
        currentIndex = target > maxSteps ? maxSteps : target;
        updateSliderPosition();
      });
    });

    window.addEventListener('resize', updateSliderPosition);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highfy-must-haves-carousel"] && !Shopify.designMode) return;
  try {
    

(function() {

  function initializeBentoCarousel(wrapper) {

    if (
      !wrapper ||
      wrapper.dataset.bentoInitialized === "true"
    ) {
      return;
    }

    wrapper.dataset.bentoInitialized = "true";

    const track = wrapper.querySelector(
      ".bento-carousel-track"
    );

    const cards = Array.from(
      wrapper.querySelectorAll(
        ".bento-carousel-card"
      )
    );

    const previousButton = wrapper.querySelector(
      ".bento-prev-btn"
    );

    const nextButton = wrapper.querySelector(
      ".bento-next-btn"
    );

    if (!track || cards.length === 0) {
      return;
    }

    let currentIndex = 0;
    let autoSlideInterval = null;
    let touchStartX = 0;
    let touchCurrentX = 0;
    let isDragging = false;
    let pointerInside = false;
    let touchActive = false;
    let resizeTimer = null;

    const slideDuration = 3200;
    const desktopGap = 24;
    const mobileGap = 16;
    const mobileBreakpoint = 768;
    const tabletBreakpoint = 991;

    function getItemsPerView() {

      if (window.innerWidth <= mobileBreakpoint) {
        return 1;
      }

      if (window.innerWidth <= tabletBreakpoint) {
        return 2;
      }

      return 3;
    }

    function getMaxSteps() {

      const itemsPerView = getItemsPerView();

      if (window.innerWidth <= mobileBreakpoint) {
        return Math.max(0, cards.length - 1);
      }

      return Math.max(
        0,
        cards.length - itemsPerView
      );
    }

    function updateNavigationState() {

      const navigationDisabled =
        getMaxSteps() === 0;

      if (previousButton) {
        previousButton.disabled =
          navigationDisabled;
      }

      if (nextButton) {
        nextButton.disabled =
          navigationDisabled;
      }
    }

    function normalizeCurrentIndex() {

      const maxSteps = getMaxSteps();

      if (currentIndex > maxSteps) {
        currentIndex = maxSteps;
      }

      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    function updateSliderPosition() {

      normalizeCurrentIndex();

      const cardWidth =
        cards[0].getBoundingClientRect().width;

      const currentGap =
        window.innerWidth <= mobileBreakpoint
          ? mobileGap
          : desktopGap;

      const offsetDistance =
        currentIndex *
        (cardWidth + currentGap);

      track.style.transform =
        "translateX(-" +
        offsetDistance +
        "px)";

      updateNavigationState();
    }

    function moveToNextSlide() {

      const maxSteps = getMaxSteps();

      if (maxSteps === 0) {
        currentIndex = 0;
        updateSliderPosition();
        return;
      }

      if (currentIndex < maxSteps) {
        currentIndex += 1;
      } else {
        currentIndex = 0;
      }

      updateSliderPosition();
    }

    function moveToPreviousSlide() {

      const maxSteps = getMaxSteps();

      if (maxSteps === 0) {
        currentIndex = 0;
        updateSliderPosition();
        return;
      }

      if (currentIndex > 0) {
        currentIndex -= 1;
      } else {
        currentIndex = maxSteps;
      }

      updateSliderPosition();
    }

    function stopAutoSlide() {

      if (autoSlideInterval !== null) {
        window.clearInterval(
          autoSlideInterval
        );

        autoSlideInterval = null;
      }
    }

    function startAutoSlide() {

      stopAutoSlide();

      if (getMaxSteps() === 0) {
        return;
      }

      autoSlideInterval =
        window.setInterval(function() {

          moveToNextSlide();

        }, slideDuration);
    }

    function restartAutoSlideWhenAllowed() {

      if (!pointerInside && !touchActive) {
        startAutoSlide();
      }
    }

    if (previousButton) {

      previousButton.addEventListener(
        "click",
        function() {

          stopAutoSlide();
          moveToPreviousSlide();
          restartAutoSlideWhenAllowed();

        }
      );
    }

    if (nextButton) {

      nextButton.addEventListener(
        "click",
        function() {

          stopAutoSlide();
          moveToNextSlide();
          restartAutoSlideWhenAllowed();

        }
      );
    }

    wrapper.addEventListener(
      "mouseenter",
      function() {

        pointerInside = true;
        stopAutoSlide();

      }
    );

    wrapper.addEventListener(
      "mouseleave",
      function() {

        pointerInside = false;
        startAutoSlide();

      }
    );

    track.addEventListener(
      "touchstart",
      function(event) {

        if (
          !event.touches ||
          event.touches.length === 0
        ) {
          return;
        }

        touchActive = true;
        isDragging = true;

        touchStartX =
          event.touches[0].clientX;

        touchCurrentX =
          touchStartX;

        stopAutoSlide();

      },
      {
        passive: true
      }
    );

    track.addEventListener(
      "touchmove",
      function(event) {

        if (
          !isDragging ||
          !event.touches ||
          event.touches.length === 0
        ) {
          return;
        }

        touchCurrentX =
          event.touches[0].clientX;

      },
      {
        passive: true
      }
    );

    track.addEventListener(
      "touchend",
      function() {

        if (isDragging) {

          const movementDistance =
            touchStartX -
            touchCurrentX;

          if (
            Math.abs(movementDistance) > 50
          ) {

            if (movementDistance > 0) {
              moveToNextSlide();
            } else {
              moveToPreviousSlide();
            }
          }
        }

        isDragging = false;
        touchActive = false;
        touchStartX = 0;
        touchCurrentX = 0;

        restartAutoSlideWhenAllowed();

      }
    );

    track.addEventListener(
      "touchcancel",
      function() {

        isDragging = false;
        touchActive = false;
        touchStartX = 0;
        touchCurrentX = 0;

        restartAutoSlideWhenAllowed();

      }
    );

    window.addEventListener(
      "resize",
      function() {

        window.clearTimeout(resizeTimer);

        resizeTimer =
          window.setTimeout(function() {

            updateSliderPosition();
            restartAutoSlideWhenAllowed();

          }, 150);
      }
    );

    window.setTimeout(function() {

      updateSliderPosition();
      startAutoSlide();

    }, 100);

    if (
      "IntersectionObserver" in window
    ) {

      const observer =
        new IntersectionObserver(
          function(
            entries,
            currentObserver
          ) {

            entries.forEach(
              function(entry) {

                if (entry.isIntersecting) {

                  entry.target.classList.add(
                    "animated-active"
                  );

                  currentObserver.unobserve(
                    entry.target
                  );
                }
              }
            );

          },
          {
            root: null,
            threshold: 0.12
          }
        );

      observer.observe(wrapper);

    } else {

      wrapper.classList.add(
        "animated-active"
      );
    }
  }

  function initializeAllBentoCarousels(
    container
  ) {

    const searchArea =
      container || document;

    if (
      searchArea.matches &&
      searchArea.matches(
        '[id^="BentoSection-"]'
      )
    ) {
      initializeBentoCarousel(
        searchArea
      );
    }

    const wrappers =
      searchArea.querySelectorAll(
        '[id^="BentoSection-"]'
      );

    wrappers.forEach(
      function(wrapper) {

        initializeBentoCarousel(
          wrapper
        );

      }
    );
  }

  if (
    document.readyState === "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      function() {

        initializeAllBentoCarousels(
          document
        );

      }
    );

  } else {

    initializeAllBentoCarousels(
      document
    );
  }

  document.addEventListener(
    "shopify:section:load",
    function(event) {

      initializeAllBentoCarousels(
        event.target
      );

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highfy-picks-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const wrappers = document.querySelectorAll('[id^="PicksSection-"]');

  wrappers.forEach(wrapper => {
    const track = wrapper.querySelector('.picks-carousel-track');
    const dots = wrapper.querySelectorAll('.picks-bullet-dot');
    const cards = wrapper.querySelectorAll('.picks-carousel-card');

    if (cards.length === 0) return;

    let currentIndex = 0;
    let autoplayTimer = null;

    const isAutoplay = wrapper.getAttribute("data-autoplay") === "true";
    const autoplaySpeed = parseInt(wrapper.getAttribute("data-autoplay-speed"), 10) || 2000;
    const pauseOnHover = wrapper.getAttribute("data-pause-on-hover") === "true";

    function getItemsPerView() {
      if (window.innerWidth <= 768) return 2;
      if (window.innerWidth <= 1199) return 3;
      return 4;
    }

    function getMaxSteps() {
      const itemsPerView = getItemsPerView();
      if (window.innerWidth <= 768) return Math.max(0, cards.length - 2);
      return Math.max(0, cards.length - itemsPerView);
    }

    function updateSliderPosition() {
      const isMobile = window.innerWidth <= 768;
      const maxSteps = getMaxSteps();

      if (currentIndex > maxSteps) {
        currentIndex = maxSteps;
      }
      if (currentIndex < 0) {
        currentIndex = 0;
      }

      if (isMobile) {
        const percentageOffset = currentIndex * 52;
        const totalGap = currentIndex * 12;
        track.style.transform = `translateX(calc(-${percentageOffset}% - ${totalGap}px))`;
      } else {
        const cardWidth = cards[0].clientWidth;
        const offsetDist = currentIndex * (cardWidth + 20); 
        track.style.transform = `translateX(-${offsetDist}px)`;
      }

      dots.forEach((dot, index) => {
        if (index === currentIndex) {
          dot.classList.add('dot-active');
        } else {
          dot.classList.remove('dot-active');
        }
      });
    }

    function nextSlide() {
      const maxSteps = getMaxSteps();
      if (maxSteps === 0) return;

      if (currentIndex < maxSteps) {
        currentIndex += 1;
      } else {
        currentIndex = 0;
      }
      updateSliderPosition();
    }

    function startAutoplay() {
      if (!isAutoplay || autoplayTimer) return;
      autoplayTimer = setInterval(nextSlide, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function resetAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const target = parseInt(dot.getAttribute('data-slide-target'));
        const maxSteps = getMaxSteps();
        currentIndex = target > maxSteps ? maxSteps : target;
        updateSliderPosition();
        resetAutoplay();
      });
    });

    if (pauseOnHover) {
      wrapper.addEventListener("mouseenter", stopAutoplay);
      wrapper.addEventListener("mouseleave", startAutoplay);
    }

    window.addEventListener('resize', () => {
      updateSliderPosition();
    });

    updateSliderPosition();
    startAutoplay();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highfy-promo-carousel"] && !Shopify.designMode) return;
  try {
    
(function() {

  function initSingleCarousel(wrapper) {
    if (!wrapper || wrapper.dataset.carouselInitialized === "true") return;
    wrapper.dataset.carouselInitialized = "true";

    const track = wrapper.querySelector('.highfy-carousel-track');
    const dots = wrapper.querySelectorAll('.pagination-bullet-dot');
    const cards = wrapper.querySelectorAll('.highfy-carousel-card');
    const toggleBtn = wrapper.querySelector('.pause-icon-indicator');

    if (!track || cards.length === 0) return;

    let autoplayInterval = null;
    let currentIndex = 0;
    const duration = 3000;

    function updateSliderPosition() {
      const isMobile = window.innerWidth <= 768;
      
      if (isMobile) {
        const percentageOffset = currentIndex * 85; 
        const totalGap = currentIndex * 12;
        track.style.transform = `translateX(calc(-${percentageOffset}% - ${totalGap}px))`;
      } else {
        const cardsPerView = 3;
        const maxSteps = Math.max(0, cards.length - cardsPerView);
        
        if (currentIndex > maxSteps) {
          currentIndex = 0; 
        }
        
        const cardWidth = cards[0].clientWidth;
        const offsetDist = currentIndex * (cardWidth + 20); 
        track.style.transform = `translateX(-${offsetDist}px)`;
      }

      dots.forEach((dot, index) => {
        if (index === currentIndex) {
          dot.classList.add('dot-active');
        } else {
          dot.classList.remove('dot-active');
        }
      });
    }

    function startAutoplay() {
      if (autoplayInterval) clearInterval(autoplayInterval);
      autoplayInterval = setInterval(() => {
        const isMobile = window.innerWidth <= 768;
        const totalLimit = isMobile ? cards.length : Math.max(1, cards.length - 2);
        
        currentIndex = (currentIndex + 1) % totalLimit;
        updateSliderPosition();
      }, duration);
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    startAutoplay();

    if (toggleBtn) {
      toggleBtn.addEventListener('click', () => {
        if (toggleBtn.classList.contains('state-playing')) {
          stopAutoplay();
          toggleBtn.classList.remove('state-playing');
          toggleBtn.classList.add('state-paused');
        } else {
          startAutoplay();
          toggleBtn.classList.remove('state-paused');
          toggleBtn.classList.add('state-playing');
        }
      });
    }

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        currentIndex = parseInt(dot.getAttribute('data-slide-target'), 10);
        updateSliderPosition();
        
        if (toggleBtn && toggleBtn.classList.contains('state-playing')) {
          startAutoplay();
        }
      });
    });

    window.addEventListener('resize', updateSliderPosition);
    updateSliderPosition();
  }

  function initAllCarousels(container) {
    const searchScope = container || document;
    
    if (searchScope.matches && searchScope.matches('[id^="CarouselSection-"]')) {
      initSingleCarousel(searchScope);
    }

    const wrappers = searchScope.querySelectorAll('[id^="CarouselSection-"]');
    wrappers.forEach(wrapper => initSingleCarousel(wrapper));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAllCarousels(document));
  } else {
    initAllCarousels(document);
  }

  document.addEventListener("shopify:section:load", (event) => initAllCarousels(event.target));

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quetee-influencer-reels"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const wrappers = document.querySelectorAll('[id^="ReelsSection-"]');

  wrappers.forEach(wrapper => {
    const track = wrapper.querySelector('.reels-carousel-track');
    const dots = wrapper.querySelectorAll('.reels-bullet-dot');
    const cards = wrapper.querySelectorAll('.reels-carousel-card');
    const prevBtn = wrapper.querySelector('.arrow-prev');
    const nextBtn = wrapper.querySelector('.arrow-next');

    if (cards.length === 0) return;

    let currentIndex = 0;

    function getItemsPerView() {
      if (window.innerWidth <= 768) return 2;
      if (window.innerWidth <= 991) return 3;
      if (window.innerWidth <= 1200) return 4;
      return 5;
    }

    function getMaxSteps() {
      const itemsPerView = getItemsPerView();
      if (window.innerWidth <= 768) return Math.max(0, cards.length - 2);
      return Math.max(0, cards.length - itemsPerView);
    }

    function updateSliderPosition() {
      const isMobile = window.innerWidth <= 768;
      const maxSteps = getMaxSteps();

    if (currentIndex > maxSteps) {
        currentIndex = maxSteps;
      }
      if (currentIndex < 0) {
        currentIndex = 0;
      }

      if (isMobile) {
        const percentageOffset = currentIndex * 52;
        const totalGap = currentIndex * 12;
        track.style.transform = `translateX(calc(-${percentageOffset}% - ${totalGap}px))`;
      } else {
        const cardWidth = cards[0].clientWidth;
        const offsetDist = currentIndex * (cardWidth + 20); 
        track.style.transform = `translateX(-${offsetDist}px)`;
      }

      dots.forEach((dot, index) => {
        if (index === currentIndex) {
          dot.classList.add('dot-active');
        } else {
          dot.classList.remove('dot-active');
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const maxSteps = getMaxSteps();
        if (currentIndex < maxSteps) {
          currentIndex++;
        } else {
          currentIndex = 0; 
        }
        updateSliderPosition();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        if (currentIndex > 0) {
          currentIndex--;
        } else {
          currentIndex = getMaxSteps(); 
        }
        updateSliderPosition();
      });
    }

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const target = parseInt(dot.getAttribute('data-slide-target'));
        const maxSteps = getMaxSteps();
        currentIndex = target > maxSteps ? maxSteps : target;
        updateSliderPosition();
      });
    });

    window.addEventListener('resize', updateSliderPosition);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quetee-modern-faqs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const wrappers = document.querySelectorAll('[id^="FaqsSection-"]');

  wrappers.forEach(wrapper => {
    const nodes = wrapper.querySelectorAll('.faq-accordion-node');

    nodes.forEach(node => {
      const trigger = node.querySelector('.faq-toggle-trigger');
      const drawer = node.querySelector('.faq-content-drawer');

      if (!trigger || !drawer) return;

      // Set initial heights for the active defaults loop index mapping
      if (node.classList.contains('faq-node-open')) {
        drawer.style.maxHeight = drawer.scrollHeight + "px";
      }

      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        const isOpen = node.classList.contains('faq-node-open');

        // Close other sibling tracking entries inside this section canvas instance
        nodes.forEach(sibling => {
          if (sibling !== node && sibling.classList.contains('faq-node-open')) {
            sibling.classList.remove('faq-node-open');
            const siblingTrigger = sibling.querySelector('.faq-toggle-trigger');
            const siblingDrawer = sibling.querySelector('.faq-content-drawer');
            if (siblingTrigger) siblingTrigger.setAttribute('aria-expanded', 'false');
            if (siblingDrawer) siblingDrawer.style.maxHeight = "0";
          }
        });

        // Toggle selected target node properties parameters
        if (isOpen) {
          node.classList.remove('faq-node-open');
          trigger.setAttribute('aria-expanded', 'false');
          drawer.style.maxHeight = "0";
        } else {
          node.classList.add('faq-node-open');
          trigger.setAttribute('aria-expanded', 'true');
          drawer.style.maxHeight = drawer.scrollHeight + "px";
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quetee-premium-reels"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const sections = document.querySelectorAll('[id^="QtReelsSection-"]');

  sections.forEach(section => {
    const track = section.querySelector('.qt-reels-track');
    const cards = section.querySelectorAll('.qt-reels-card');
    const progressBar = section.querySelector('.qt-reels-progress-inner');

    if (cards.length === 0) return;

    let currentIndex = 0;

    function getItemsPerView() {
      if (window.innerWidth <= 768) return 1;
      if (window.innerWidth <= 991) return 3;
      if (window.innerWidth <= 1200) return 4;
      return 5;
    }

    function getMaxSteps() {
      const itemsPerView = getItemsPerView();
      if (window.innerWidth <= 768) return cards.length - 1;
      return Math.max(0, cards.length - itemsPerView);
    }

    function updateSliderPosition() {
      const isMobile = window.innerWidth <= 768;
      const maxSteps = getMaxSteps();

      if (currentIndex > maxSteps) {
        currentIndex = maxSteps;
      }
      if (currentIndex < 0) {
        currentIndex = 0;
      }

      // Track Animation Logic
      if (isMobile) {
        const percentageOffset = currentIndex * 65;
        const totalGap = currentIndex * 14;
        track.style.transform = `translateX(calc(-${percentageOffset}% - ${totalGap}px))`;
      } else {
        const cardWidth = cards[0].clientWidth;
        const offsetDist = currentIndex * (cardWidth + 20); 
        track.style.transform = `translateX(-${offsetDist}px)`;
      }

      // Progress bar percentage calculation
      if (progressBar) {
        const totalSteps = cards.length;
        const itemsInView = getItemsPerView();
        const progressPercent = ((currentIndex + itemsInView) / totalSteps) * 100;
        progressBar.style.width = `${Math.min(100, Math.max(20, progressPercent))}%`;
      }
    }

    // Touch Slide Drag Handlers for Smooth Interactive Swipe Moves
    let startX = 0;
    let isDragging = false;

    track.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      isDragging = true;
    });

    track.addEventListener('touchmove', e => {
      if (!isDragging) return;
      const diffX = startX - e.touches[0].clientX;
      if (Math.abs(diffX) > 50) {
        const maxSteps = getMaxSteps();
        if (diffX > 0 && currentIndex < maxSteps) {
          currentIndex++;
        } else if (diffX < 0 && currentIndex > 0) {
          currentIndex--;
        }
        isDragging = false;
        updateSliderPosition();
      }
    });

    track.addEventListener('touchend', () => {
      isDragging = false;
    });

    window.addEventListener('resize', updateSliderPosition);
    setTimeout(updateSliderPosition, 100);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quetee-tabbed-collections"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const sections = document.querySelectorAll('[id^="QtTabsSection-"]');

  sections.forEach(section => {
    const tabTriggers = section.querySelectorAll('.qt-tab-trigger');
    const tabPanes = section.querySelectorAll('.qt-tab-pane');

    tabTriggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        const targetId = this.getAttribute('data-tab-target');

        tabTriggers.forEach(btn => btn.classList.remove('qt-tab-active'));
        this.classList.add('qt-tab-active');

        tabPanes.forEach(pane => {
          if (pane.id === targetId) {
            pane.classList.add('qt-pane-active');
          } else {
            pane.classList.remove('qt-pane-active');
          }
        });
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
